import { render, staticRenderFns } from "./2_davichNews.vue?vue&type=template&id=8f81817a&scoped=true&"
import script from "./2_davichNews.vue?vue&type=script&lang=js&"
export * from "./2_davichNews.vue?vue&type=script&lang=js&"
import style0 from "./2_davichNews.vue?vue&type=style&index=0&id=8f81817a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8f81817a",
  null
  
)

export default component.exports